// Adds `.tabbing` class to html element once tabbing detected

export default function detectTabbing() {
  const onKeyUp = function (e) {
    const charCode = e.which || e.keyCode
    if (charCode === 9) {
      document.documentElement.classList.add('tabbing')
      document.removeEventListener('keyup', onKeyUp)
    }
  }
  document.addEventListener('keyup', onKeyUp)
}
